import React, { useEffect } from 'react';
import './assetmenu.css';
import TextEditMenu from './texteditmenu/TextEditMenu';
import GenericAssetMenu from './genericAssetMenu/GenericAssetMenu.tsx';
import { AssetType } from '../../types/typing';

interface MenuProps {
  visible: boolean;
  selectedAssetOnCanvas: {
    id: string;
    selectedAsset: AssetType;
  };
  updateTextProperties: (id: string, textProperties: any) => void;
  selectedText: any; // Callback to update text properties
  onClose: () => void; // Callback to close the menu
  onMenuClick: (menu: string) => void;
  onDeleteAsset: ({
    id,
    assetType,
  }: {
    id: string;
    assetType: AssetType;
  }) => void;
  assetMenuRef: React.RefObject<HTMLDivElement>;
  navMenuRef: React.RefObject<HTMLDivElement>;
}

const AssetMenu: React.FC<MenuProps> = ({
  visible,
  selectedAssetOnCanvas,
  updateTextProperties,
  selectedText,
  onClose,
  onMenuClick,
  onDeleteAsset,
  assetMenuRef,
  navMenuRef,
}) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        assetMenuRef.current &&
        !assetMenuRef.current.contains(event.target as Node) &&
        navMenuRef.current &&
        !navMenuRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };
    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup event listener on unmount or when `visible` changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible, onClose]);

  if (!visible) return null; // Do not render if the menu is not visible

  let menuContent = null;
  // Determine the menu to render based on the selected asset type
  switch (selectedAssetOnCanvas.selectedAsset) {
    case AssetType.TEXT:
      menuContent = (
        <TextEditMenu
          selectedAssetOnCanvas={selectedAssetOnCanvas}
          selectedText={selectedText}
          onDeleteAsset={onDeleteAsset}
          updateTextProperties={updateTextProperties}
          onMenuClick={onMenuClick}
        />
      );
      break;
    case AssetType.CHARACTER:
      menuContent = (
        <GenericAssetMenu
          selectedAssetOnCanvas={selectedAssetOnCanvas}
          onMenuClick={onMenuClick}
          onDeleteAsset={onDeleteAsset}
        />
      );
      break;
    case AssetType.RIGGED_CHARACTER:
      menuContent = (
        <GenericAssetMenu
          selectedAssetOnCanvas={selectedAssetOnCanvas}
          onMenuClick={onMenuClick}
          onDeleteAsset={onDeleteAsset}
        />
      );
      break;
    case AssetType.NONE:
      menuContent = null;
      break;
    default:
      menuContent = (
        <GenericAssetMenu
          selectedAssetOnCanvas={selectedAssetOnCanvas}
          onMenuClick={onMenuClick}
          onDeleteAsset={onDeleteAsset}
        />
      );
  }

  return (
    <div ref={assetMenuRef} className="asset-menu-container">
      {menuContent}
    </div>
  );
};

export default AssetMenu;
